import React, { useEffect, useRef, useState } from 'react';
import { Card, Button, Tabs, Tab} from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../Auth';
import Field from '../../../Shared/Wizard/Field/Field';

function EventGeneral(props) {
    const t = useTranslate();
    const auth = useAuth();

    // Used to refresh values on page
    const [editEvent, setEditEvent] = useState({
        periods: [""],
    } as any);
    

    function handleChange(val, field) {
        let tempEvent = props.event;
        tempEvent[field] = val;
        if (props.onChange != undefined) {
            props.onChange(JSON.parse(JSON.stringify(tempEvent)));
        }
    }
    
    const setEditEventPeriods = value => { 
        setEditEvent(temp => ({ ...temp, periods: value }));
        if (props.onChange != undefined) {
            props.onChange(temp => ({ ...temp, periods: value }));
        }
     }

    const addEditPeriod = () => {
        setEditEventPeriods([...props.event.periods != undefined ? props.event.periods : [], { name: "", value: "" }]);
    }

    const handleEditPeriodFrom = (val, key) => {
        let temp = props.event != undefined ? props.event : [];
        temp["periods"][key]["from"] = val;
        setEditEventPeriods(JSON.parse(JSON.stringify(temp["periods"])));
        if (props.onChange != undefined) {
            props.onChange(temp);
        }
    }
    const handleEditPeriodTo = (val, key) => {
        let temp = props.event != undefined ? props.event : [];
        temp["periods"][key]["to"] = val;
        setEditEventPeriods(JSON.parse(JSON.stringify(temp["periods"])));
        if (props.onChange != undefined) {
            props.onChange(temp);
        }
    }
    const deleteEditPeriod = (key) => {
        let temp = props.event;
        temp["periods"].splice(key, 1);
        setEditEventPeriods(JSON.parse(JSON.stringify(temp)));
        if (props.onChange != undefined) {
            props.onChange(temp);
        }
    }

    return (
        <div style={{ marginTop: '20px' }}>
            <h3>{t("event.general.title")}</h3>
            <Card>
                <Card.Body>
                    <Field
                        type="input"
                        title={t("events.new_name")}
                        value={props.event.name != undefined ? props.event.name : ""}
                        onChange={val => handleChange(val, "name")}
                        disabled={ auth.user["userdata"]["orgRole"][0] == "janitor" }
                    ></Field>
                    <Field
                        type="selectcolor"
                        title={t("events.new_color")}
                        value={props.event.color != undefined ? props.event.color : ""}
                        onChange={val => handleChange(val, "color")}
                        placeholder={t("events.new_color")}
                        disabled={ auth.user["userdata"]["orgRole"][0] == "janitor" }
                    ></Field>
                    <Field
                        type="input"
                        title={t("events.new_description")}
                        value={props.event.description != undefined ? props.event.description : ""}
                        onChange={val => handleChange(val, "description")}
                        placeholder={t("events.new_description")}
                        disabled={ auth.user["userdata"]["orgRole"][0] == "janitor" }
                    ></Field>
                    <Field
                        type="input"
                        title={t("events.headCount")}
                        value={props.event.maximumHeadcount != undefined ? props.event.maximumHeadcount : ""}
                        onChange={val => handleChange(val, "maximumHeadcount")}
                        placeholder={t("events.headCount")}
                        disabled={ auth.user["userdata"]["orgRole"][0] == "janitor" }
                    ></Field>
                    {
                        props.event["periods"] != undefined ? props.event["periods"].map((item, key) =>
                            <div className="periodContainer row " key={key}  style={{ paddingTop: "40px" }} >
                                <div className="col col-sm-5">
                                    <Field
                                        type="dateselector"
                                        title={t("events.period_from")}
                                        showtimeselect
                                        value={item["from"]}
                                        onChange={(val) => { handleEditPeriodFrom(val, key) }}
                                        disabled={ auth.user["userdata"]["orgRole"][0] == "janitor" }
                                    ></Field>
                                </div>
                                <div className="col col-sm-5">
                                    <Field
                                        type="dateselector"
                                        title={t("events.period_to")}
                                        showtimeselect
                                        value={item["to"]}
                                        onChange={(val) => { handleEditPeriodTo(val, key) }}
                                        disabled={ auth.user["userdata"]["orgRole"][0] == "janitor" }
                                    ></Field>
                                </div>
                                <div className="col-sm-2">
                                    { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                                        <Button onClick={() => deleteEditPeriod(key)}>{t("events.period_delete")}</Button>
                                    : null }
                                </ div>
                            </div>
                        ) : null
                    }
                    { auth.user["userdata"]["orgRole"][0] != "janitor" ?
                        <Button onClick={addEditPeriod}>{t("events.period_add")}</Button>
                    : null }
                </Card.Body>
                <Card.Footer>
                {/* <Button onClick={handleEditEvent}>
                        {t("events.save")}
                    </Button> */}
                </Card.Footer>
            </Card>
        </div>
    )
}


export default EventGeneral;